import isEmpty from 'lodash/isEmpty';
import isBoolean from 'lodash/isBoolean';

const buildURLQuery = (obj: { [key: string]: string | number | boolean | undefined | null }) =>
  Object.entries(obj)
    .filter((key) => (isBoolean(key[1]) ? true : !isEmpty(key[1])))
    .map((pair) => (pair as [string, string | number | boolean]).map(encodeURIComponent).join('='))
    .join('&');

export default buildURLQuery;
